import React from 'react';
import {CreateRequestForm} from '../form';
import {Modal} from '../../../../../shared/components/modal/modal';
import {IStateProps} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';

export default ({onClose, onSuccessFormSubmit}: IStateProps) => {
  const styles = useStyles(() => ({
    modalWrap: {
      paddingHorizontal: 90,
      width: 930,
    },
    modalContent: {
      paddingTop: 31,
      display: 'flex',
      flexDirection: 'column',
    },
    modalTitle: {
      paddingTop: 0,
    },
  }));

  return (
    <Modal
      titleStyle={styles.modalTitle}
      contentStyle={styles.modalContent}
      wrapStyle={styles.modalWrap}
      onClose={onClose}
      allowClicksThroughOverlay={false}
      title='Новое обращение'>
      <CreateRequestForm onSuccessSubmit={onSuccessFormSubmit} />
    </Modal>
  );
};
